import React, { ReactNode } from "react"
import styles from "./FormControlWithAdd.module.scss"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { FieldArray } from "formik"
import { FieldArrayRenderProps } from "formik/dist/FieldArray"
import IconControl from "../../IconControl/IconControl"
import { testId as commonTestIds } from "../../../utility/tests/testId/common"

export interface FormControlWithAddProps {
    name: string
    label: string
    icon?: JSX.Element
    onCreateEmptyValue: () => unknown
    children: (arrayHelpers: FieldArrayRenderProps) => ReactNode
    small?: boolean
    testId?: string
}

const FormControlWithAdd: React.FC<FormControlWithAddProps> = props => {
    const { name, label, icon, onCreateEmptyValue, children, small, testId = commonTestIds.formControlWithAdd } = props
    return (
        <FieldArray
            data-testid={testId}
            name={name}
            render={arrayHelpers => (
                <>
                    <div className={styles.formControlWithAdd__addSection}>
                        <div className={small ? styles.formControlWithAdd__labelSmall : undefined}>
                            {label}
                            {icon}
                        </div>

                        <IconControl
                            icon={faPlus}
                            className={styles.formControlWithAdd__addButton}
                            onClick={() => arrayHelpers.push(onCreateEmptyValue())}
                            testId={`${testId}-add-button`}
                        />
                    </div>
                    {children(arrayHelpers)}
                </>
            )}
        />
    )
}

export default FormControlWithAdd
